import withGS from '../core/withGShoc';
import PropTypes from 'prop-types';
import React from 'react';
import GS from '../grafsync/grafsync';


class BasicWrapper extends React.Component {

  render() {

    const { component, id, graph } = this.props;
    const WrappedComponent = component;

    const data = GS.data(id, graph);
    if (data.deprecated || data.pendingDeletion) return null;

    return (
      <WrappedComponent {...this.props} />
    );
  }
}

BasicWrapper.propTypes = {
  id: PropTypes.string,
  component: PropTypes.oneOfType([
    PropTypes.func,
    PropTypes.object
  ]),
  graph: PropTypes.string.isRequired
};

export default withGS(BasicWrapper, ["ALL"], null, {}, false);